exports.onRouteUpdate = ({ location, prevLocation }) => {
  window.prevLocation =
    typeof window !== 'undefined' && prevLocation ? prevLocation.pathname : null
}
